import { useContext } from "react";
import JobCard from "../../components/JobCard";
import SkeletonCard from "../../components/SkeletonCard";
import { JobContext } from "../../context/JobContext";

const JobPage = () => {
  const { states, actions } = useContext(JobContext);

  const {
    filteredJobs,
    loading,
    error,
    search,
    city,
    company,
    salaryRange,
    cities,
    companies,
    salaryOptions,
  } = states;

  const {
    setSearch,
    setCity,
    setCompany,
    setSalaryRange,
    normalizeCity,
    formatRupiah,
    handleStatus,
  } = actions;

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <div className="text-center mb-10">
        <h1 className="text-3xl sm:text-4xl font-bold">
          Cari <span className="text-indigo-600">Lowongan</span> Pekerjaan
        </h1>
        <p className="text-gray-600 mt-2">
          Temukan pekerjaan yang sesuai dengan keahlianmu
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        <div className="lg:col-span-1">
          <div className="bg-white border rounded-xl p-4 space-y-4">
            <h2 className="font-semibold text-lg">Filter</h2>

            <input
              type="text"
              placeholder="Cari pekerjaan..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border rounded-lg px-4 py-2 text-sm w-full"
            />

            <select
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="border rounded-lg px-4 py-2 text-sm w-full">
              <option value="">Semua Kota</option>
              {cities.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>

            <select
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              className="border rounded-lg px-4 py-2 text-sm w-full">
              <option value="">Semua Perusahaan</option>
              {companies.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>

            <select
              value={salaryRange}
              onChange={(e) => setSalaryRange(e.target.value)}
              className="border rounded-lg px-4 py-2 text-sm w-full">
              <option value="">Semua Gaji</option>
              {salaryOptions.map((s) => (
                <option key={s.label} value={`${s.min}-${s.max}`}>
                  {s.label}
                </option>
              ))}
            </select>

            <button
              onClick={() => {
                setSearch("");
                setCity("");
                setCompany("");
                setSalaryRange("");
              }}
              className="w-full text-sm border border-gray-300 rounded-lg py-2 hover:bg-gray-100">
              Reset Filter
            </button>
          </div>
        </div>

        <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {loading &&
            Array.from({ length: 6 }).map((_, i) => <SkeletonCard key={i} />)}

          {!loading && error && (
            <p className="text-red-500 font-semibold">{error}</p>
          )}

          {!loading &&
            !error &&
            filteredJobs.map((job) => (
              <JobCard
                key={job._id}
                job={job}
                normalizeCity={normalizeCity}
                formatRupiah={formatRupiah}
                handleStatus={handleStatus}
                showDetailButton={true}
              />
            ))}

          {!loading && filteredJobs.length === 0 && (
            <p className="text-gray-500 col-span-full">
              Lowongan tidak ditemukan
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default JobPage;
